import { Component, Input } from '@angular/core';
import { MatDialogRef } from '@angular/material/dialog';
import { Router } from '@angular/router';
import { GetterCampaignData } from '@vendasta/campaigns';
import { ActionList } from '../action-list';
import { UserList } from '../users/user-list';

export interface ActionListDialogData {
  [key: string]: unknown;
  // TODO: temporary until we phase out old workflow and `bulk_actions_v2` is GA
  useBulkActionsMicroservice?: boolean;
}

export enum ListType {
  AccountList = 0,
  UserList = 1,
  CampaignList = 2,
}

@Component({
  template: ``, // required, but overridden by the components that extend this
  styleUrls: ['../../common/dialog.component.scss', './action-list-dialog.component.scss'],
  standalone: false,
})
export class ActionListDialogComponent {
  private _actionList: ActionList;
  private _userList: UserList;
  private _campaign: GetterCampaignData;
  listName = '';
  listId = '';
  itemCount = 0;
  availableActionLists: ActionList[];
  listType: ListType;
  campaignId: string;
  campaignName: string;

  @Input()
  set campaign(val: GetterCampaignData) {
    this.listType = ListType.CampaignList;
    this.campaignId = val.campaignId;
    this.campaignName = val.name;
    this._campaign = val;
  }

  @Input()
  set actionList(val: ActionList) {
    this.listType = ListType.AccountList;
    this._actionList = val;
    this.listId = val.id;
    this.listName = val.name;
    this.itemCount = val.accounts;
  }

  get actionList(): ActionList {
    return this._actionList;
  }

  @Input()
  set actionLists(val: ActionList[]) {
    this.availableActionLists = val;
  }

  @Input()
  set userList(val: UserList) {
    this.listType = ListType.UserList;
    this._userList = val;
    this.listId = val.listId;
    this.listName = val.userListName;
    this.itemCount = val.numUsers;
  }

  get userList(): UserList {
    return this._userList;
  }

  constructor(
    public dialogRef: MatDialogRef<ActionListDialogComponent>,
    public router: Router,
  ) {}
}
